module.exports = __webpack_public_path__ + "62214d7a.png";